// Mobile drawer / desktop side-sheet via vaul. Used for the unlock modal on
// mobile and the admin filters drawer.
import { Drawer as Vaul } from "vaul";
import { forwardRef } from "react";
import { cn } from "../cn.ts";

export const Sheet = Vaul.Root;
export const SheetTrigger = Vaul.Trigger;
export const SheetClose = Vaul.Close;
export const SheetPortal = Vaul.Portal;

export const SheetOverlay = forwardRef<
  React.ElementRef<typeof Vaul.Overlay>,
  React.ComponentPropsWithoutRef<typeof Vaul.Overlay>
>(function SheetOverlay({ className, ...rest }, ref) {
  return (
    <Vaul.Overlay
      ref={ref}
      className={cn("fixed inset-0 z-50 bg-black/60 backdrop-blur-sm", className)}
      {...rest}
    />
  );
});

export const SheetContent = forwardRef<
  React.ElementRef<typeof Vaul.Content>,
  React.ComponentPropsWithoutRef<typeof Vaul.Content>
>(function SheetContent({ className, children, ...rest }, ref) {
  return (
    <SheetPortal>
      <SheetOverlay />
      <Vaul.Content
        ref={ref}
        className={cn(
          "fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col rounded-t-2xl bg-[var(--brand-paper)] p-6 shadow-2xl",
          className,
        )}
        {...rest}
      >
        <div aria-hidden className="mx-auto mb-4 h-1 w-12 rounded-full bg-[var(--brand-border)]" />
        {children}
      </Vaul.Content>
    </SheetPortal>
  );
});

export const SheetTitle = forwardRef<HTMLHeadingElement, React.HTMLAttributes<HTMLHeadingElement>>(
  function SheetTitle({ className, ...rest }, ref) {
    return (
      <h2
        ref={ref}
        className={cn("font-heading text-lg font-semibold text-[var(--brand-ink)]", className)}
        {...rest}
      />
    );
  },
);
